export type Environment = 'dev' | 'staging' | 'production';

/**
 * Defaults to `staging` if not in production to mimic current localhost's API clients behaviour
 * @param useDev set to true to dinamically return `dev` if current subdomain is `localhost` or `local`
 */
export const getEnvironment = (useDev?: boolean): Environment => {
	// Don't check for `window` if in a node environment
	const isBrowser = Boolean(typeof window !== 'undefined' && window.IS_STATIC);
	if (useDev && isBrowser && window.location.hostname.includes('local')) {
		return 'dev';
	}

	return process.env['NODE_ENV'] === 'production' ? 'production' : 'staging';
};
